<template>
    <div class="modal fade" role="dialog" :id="modalId">
        <div class="modal-dialog m-0" role="document">
            <div class="modal-content" style="border-radius: 0">
                <div
                    class="modal-body p-0 vh-100 d-flex justify-content-center align-items-center"
                    style="background-color: black;"
                >
					<div
						class="align-items-center d-flex d-flex-between justify-content-between p-3 position-absolute z-99"
						style="background-color: rgba(0, 0, 0, 0.4); top: 0; left: 0; right: 0; position: absolute;">
						<img
							src="@/assets/icons/close-white.svg"
							alt=""
							@click="close()"
						/>
						<i
							v-if="!isVideo"
							class="fas fa-search search-icon text-white"
							@click="zoom = !zoom"
						/>
					</div>
					<video
						controls
						v-if="isVideo"
						style="width: 100%; height: 100vh"
					>
						<source :src="url" :type="contentType">
					</video>
					<div v-else class="overflow-auto flex-1" style="max-height: 100vh">
						<img :src="url" class="preview-image" :class="{'zoom': zoom}" alt="" style="height: 100%"/>
					</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    created() {
        this.$router.beforeEach((to, from, next) => {
            this.back()
            next()
        })
    },
    name: 'SOImagePreview',
    props: {
        modalId: {
            type: String,
            default: 'modalImagePreview'
        }
    },
    data() {
        return {
            url: null,
            contentType: null,
            isVideo: false,
			zoom: false
        }
    },
    methods: {
        close() {
            this.url = null
            this.contentType = null
            this.isVideo = false
            $("#" + this.modalId).modal("hide");
        },
        open(imageSrc, contentType) {
			this.zoom = false
            this.url = imageSrc
            this.contentType = contentType
            this.isVideo = contentType.includes('video')
            $("#" + this.modalId).modal("show");
        },
        back() {
            $("#" + this.modalId).modal("hide");
        }
    }
}
</script>

<style scoped>
.modal-content .preview-image {
	width: 100%;
	transition: all ease-in-out 300ms;
}
.preview-image.zoom {
	width: 150%;
}
</style>